import styled from 'styled-components';

const Button = styled.div`
    font-size: 1rem;
    height: 3.125rem;
    line-height: 3.125rem;
    width: 100%;
    display: inline-block;
    text-align: center;
    color: ${props => props.disabled ? '#7E7E7E' : props.theme.mainBtn.txt};
    background: ${props => props.disabled ? '#AAAAAA' : props.theme.mainBtn.bg};
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    
    @media only screen and (min-width:500px) {
        font-size: 1.125rem;
    }
`;

export default Button;